import React from 'react'
import { TEAMS_URL } from '../../Routing/urls'
import type { TeamStanding } from '../../Api'
import { logEvent, getFullTeamName } from '../../Utils'
import { Lk } from '../Links/Lk'

type HeaderProps = {
  items: TeamStanding[]
  showTies: boolean
  section: string
}

export const StandingsTableRows: React.FC<React.PropsWithChildren<HeaderProps>> = ({
  items,
  section,
  showTies,
}) => {
  const log = (event: string, teamId: string) => {
    logEvent(event, {
      section: section,
      team: getFullTeamName(teamId),
    })
  }

  return (
    <>
      {items.map((standingsTeam) => (
        <tr key={standingsTeam.team.officialId}>
          <td>
            <Lk link={`${TEAMS_URL}/${standingsTeam.team.fullName}`} alt={standingsTeam.team.fullName}>
              <span
                onClick={() =>
                  log('standings_team_click', standingsTeam.team.officialId)
                }
              >
                {`${
                  standingsTeam?.team?.location
                    ? ` ${standingsTeam.team.location} ${standingsTeam.team.fullName}`
                    : standingsTeam.team.fullName
                }`}
              </span>
            </Lk>
          </td>
          <td>
            {standingsTeam?.wins
              ? standingsTeam.wins
              : standingsTeam?.csWins
              ? standingsTeam.csWins
              : 0}
          </td>
          <td>
            {standingsTeam?.losses
              ? standingsTeam.losses
              : standingsTeam?.csLosses
              ? standingsTeam.csLosses
              : 0}
          </td>
          {showTies && (
            <td>
              {standingsTeam?.ties
                ? standingsTeam.ties
                : standingsTeam?.csTies
                ? standingsTeam.csTies
                : 0}
            </td>
          )}
          <td>
            {standingsTeam?.scores
              ? standingsTeam.scores
              : standingsTeam?.csScores
              ? standingsTeam.csScores
              : 0}
          </td>
          <td>
            {standingsTeam?.scoresAgainst
              ? standingsTeam.scoresAgainst
              : standingsTeam?.csScoresAgainst
              ? standingsTeam.csScoresAgainst
              : 0}
          </td>
          <td>
            {standingsTeam?.scoreDiff
              ? standingsTeam.scoreDiff
              : standingsTeam?.csScoreDiff
              ? standingsTeam.csScoreDiff
              : 0}
          </td>
        </tr>
      ))}
    </>
  )
}
